import { NavigationGuard } from "vue-router";
import { appConfigGet } from "../practitioner-portal/store/app-config";
import { lang } from "../../i18n";

export const resolvePatientLocale: NavigationGuard = async (to, from, next) => {
  lang.setLocale((await appConfigGet()).data.platform.locale);
  next();
};
